import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import EmptyWidgets from "@/assets/empty-states/empty_widgets.svg";
import { HomeDashboardSelect } from "@/components/pages/dashboard/home-page/HomeDashboardSelect";

export const EmptyHomeDashboardPage: FC = () => {
  return (
    <Stack height="90dvh" alignItems="center" justifyContent="center">
      <img src={EmptyWidgets} alt="EmptyDashboard" />

      <Typography variant="h5" fontWeight="bold" mt={5}>
        No Home Dashboard Selected Yet
      </Typography>

      <Typography
        mt={2}
        variant="h6"
        fontWeight="normal"
        color="text.secondary"
        width={640}
        align="center"
      >
        Pick your favorite dashboard to set as your Homepage and quickly see
        what's important every time you log in.
      </Typography>

      <Box mt={4}>
        <HomeDashboardSelect />
      </Box>
    </Stack>
  );
};
